<template>
  <footer
    class="uk-navbar-container uk-navbar-transparent uk-padding-small uk-padding-remove-vertical uk-background-secondary text-white"
    uk-navbar
  >
    <div class="uk-navbar-left">
      &copy; Tomasz Miśków
    </div>
    <div class="uk-navbar-right"></div>
  </footer>
</template>

<script>
export default {
  name: "Footer"
};
</script>

<style scoped></style>
